// extracted by mini-css-extract-plugin
export default {"checkbox":"UVNap5","checkbox--form":"jJRTMV","checkboxForm":"jJRTMV","checkbox--disabled":"vb5QKo","checkboxDisabled":"vb5QKo","checkbox__item":"Dr7jhD","checkboxItem":"Dr7jhD"};